<div class="wbx-confirmation-window" *ngIf="currentConfig && show">
  <div
    class="wbx-confirmation-window-inner"
    [ngClass]="{
      'wbx-confirmation-window-inner-error': currentConfig?.type === 'error',
      'wbx-confirmation-window-inner-success': currentConfig?.type === 'success',
      'wbx-confirmation-window-inner-warning': currentConfig?.type === 'warning'
    }"
  >
    <div class="wbx-confirmation-window-icons"></div>

    <div class="wbx-confirmation-window-content">
      <h4>{{ currentConfig?.title }}</h4>
      <p>{{ currentConfig?.message }}</p>
    </div>

    <div class="wbx-confirmation-window-actions">
      <button class="wbx-btn-yes-btn" id="yesBtn" (click)="onYes()">
        {{ currentConfig?.yesText || ('GLOBAL.KEYS.YES_BUTTON' | translate) }}
      </button>
      <button class="wbx-btn-no-btn" id="noBtn" (click)="onNo()">
        {{ currentConfig?.noText || ('GLOBAL.KEYS.NO_BUTTON' | translate) }}
      </button>
    </div>
  </div>
</div>
